import styled from 'styled-components';

export const StyledLegalNoticeParagraph = styled.span<{ withLogo: boolean }>`
  height: 28px;
  font-weight: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.black};
  display: block;
  margin: ${({ withLogo }) => (withLogo ? '0px' : 'inherit')};
  white-space: pre-line;
`;

export const StyledContainer = styled.div`
  display: flex;
  width: 750px;
  align-items: center;
  justify-content: flex-start;
  margin-bottom : 36px;
  @media only screen and (max-width: 768px){
    display: block;
  }
`;

export const StyledCliplogo = styled.img<{ experience: string }>`
  width: ${({ experience }) => (experience === 'hyundai' ? '248px' : '170px')};
  padding: 0;
  `;
